import Immutable from 'immutable';
import {
  FLAG_GETTING_DRIVER_COMMISSIONS,
  GET_DRIVER_COMMISSIONS,
  CLEAR_DRIVER_COMMISSIONS,
  FLAG_DRIVER_COMMISSION_ACTIVITY,
  GET_DRIVER_COMMISSION,
  CLEAR_DRIVER_COMMISSION
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_DRIVER_COMMISSIONS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_DRIVER_COMMISSIONS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_DRIVER_COMMISSIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_DRIVER_COMMISSION_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DRIVER_COMMISSION:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_DRIVER_COMMISSION:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );
    default:
      return state;
  }
};
